import React from 'react';

const CustomerCard = ({ customer, extraContent }) => {
  if (!customer) return null;

  const name = typeof customer === 'string' ? customer : (customer.displayName || customer.name || '—');
  const preferredName = typeof customer === 'object' ? customer.preferredName : '';
  const gender = typeof customer === 'object' ? customer.gender : '';
  const phone = typeof customer === 'object' ? customer.phone : '';
  const age = typeof customer === 'object' ? (customer.age || (customer.ageYears ? `${customer.ageYears} yrs` : '')) : '';
  
  let address = '';
  if (typeof customer === 'object' && customer !== null) {
    if (typeof customer.address === 'string') {
      address = customer.address;
    } else if (customer.address && typeof customer.address === 'object') {
      const parts = [
        customer.address.suite || customer.address.address1 || customer.address.street,
        customer.address.city,
        customer.address.state,
        customer.address.postcode || customer.address.zip,
      ].filter(Boolean);
      address = parts.join(', ');
    } else if (customer.locality) {
      address = customer.locality;
    }
  }

  return (
    <div className="info-card customer-card">
      <h2 className="card-title">Customer</h2>
      <div className="info-row">
        <span className="label">Name:</span>
        <span className="value"><strong>{name}</strong></span>
      </div>
      {preferredName ? (
        <div className="info-row">
          <span className="label">Preferred Name:</span>
          <span className="value">{preferredName}</span>
        </div>
      ) : null}
      {gender ? (
        <div className="info-row">
          <span className="label">Gender:</span>
          <span className="value">{gender}</span>
        </div>
      ) : null}
      {age ? (
        <div className="info-row">
          <span className="label">Age:</span>
          <span className="value">{age}</span>
        </div>
      ) : null}
      <div className="info-row">
        <span className="label">Phone:</span>
        <span className="value">{phone || '—'}</span>
      </div>
      <div className="info-row">
        <span className="label">Address:</span>
        <span className="value">{address || '—'}</span>
      </div>
      {extraContent}
    </div>
  );
};

export default CustomerCard;
